import styled from 'styled-components';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import { THEME } from '@/styles/theme';

export const ContentLayoutWrapper = styled.div`
  ${flex({ flexDirection: 'column' })};
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
`;

export const ContentLayoutMain = styled.div`
  ${flex({ flexDirection: 'column' })};
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: #fafafa;
  padding: 20px 36px 36px;

  ${media.tablet`
    border-radius: 0;
    padding: 24px 24px;
  `}

  ${media.mobile`
    padding: 24px 16px;
  `}
`;

export const ContentWrapper = styled.div`
  ${flex({ flexDirection: 'column' })};
  width: 100%;
  flex: 1;
`;

export const BannerWrapper = styled.div`
  top: 0;
  position: sticky;
  z-index: ${THEME.banner.zIndex};

  ${media.tablet`
    width: 100%;
  `}
`;
